<ng-container *transloco="let t">
  <div
    class="form-group question-container-inner person"
    [formGroup]="questionForm()"
  >
    <lib-input-container
      [headLine]="
        question().translations?.list['headLine']
          | translate: activeLang() : question().structure.headLine
      "
      [description]="
        question().translations?.list['description']
          | translate: activeLang() : question().structure.description
      "
      [labelPrefix]="questionNumber$ | async"
      [label]="
        isChangeRequest()
          ? !isProjectManager()
            ? t('begaran_coordinator_signatory')
            : t('person_project_manager')
          : !isProjectManager()
            ? t('person_signatory')
            : t('person_project_manager')
      "
      [labelHeader]="true"
      [questionMarkText]="
        question().translations?.list['questionMarkText']
          | translate: activeLang() : question().structure.questionMarkText
      "
      [required]="question().validation.required && !isChangeRequest()"
      [requiredTextEnd]="false"
      [helpText]="
        question().translations?.list['helpText']
          | translate: activeLang() : question().structure.helpText
      "
      [markRequired]="isChangeRequest()"
    >
      @if (isChangeRequest()) {
        <div class="col-12 col-md-10">
          <lib-list>
            <lib-list-item [editMode]="true" [hideClose]="true">
              <div edit-title class="person-title">
                {{
                  isProjectManager()
                    ? t('begaran_current_project_manager')
                    : t('begaran_current_signatory')
                }}
              </div>
              <div edit>
                @if (question().structure.firstName) {
                  <div class="mt-2">
                    <lib-input-container
                      [label]="t('person_firstname')"
                      [markRequired]="true"
                      [width]="'medium'"
                    >
                      <div class="readonly">
                        {{
                          isProjectManager()
                            ? begaran()?.projektledare?.firstName
                            : begaran()?.firmatecknareList[0]?.firstName
                        }}
                      </div>
                    </lib-input-container>
                  </div>
                }
                @if (question().structure.lastName) {
                  <div class="mt-2">
                    <lib-input-container
                      [label]="t('person_lastname')"
                      [markRequired]="true"
                      [width]="'medium'"
                    >
                      <div class="readonly">
                        {{
                          isProjectManager()
                            ? begaran()?.projektledare?.lastName
                            : begaran()?.firmatecknareList[0]?.lastName
                        }}
                      </div>
                    </lib-input-container>
                  </div>
                }

                @if (question().structure.email) {
                  <div class="mt-2">
                    <lib-input-container
                      [label]="t('person_email')"
                      [width]="'medium'"
                      [markRequired]="true"
                    >
                      <div class="readonly">
                        {{
                          isProjectManager()
                            ? begaran()?.projektledare?.email
                            : begaran()?.firmatecknareList[0]?.email
                        }}
                      </div>
                    </lib-input-container>
                  </div>
                }
                @if (question().structure.phone) {
                  <div class="mt-2">
                    <lib-input-container
                      [label]="t('person_phone')"
                      [markRequired]="true"
                      [width]="'medium'"
                    >
                      <div class="readonly">
                        {{ begaran()?.projektledare?.phone }}
                      </div>
                    </lib-input-container>
                  </div>
                }
                @if (question().structure.sex) {
                  <div class="mt-2">
                    <lib-input-container
                      [label]="t('person_sex')"
                      [markRequired]="true"
                      [width]="'medium'"
                      [requiredTextEnd]="false"
                    >
                      <div class="readonly">
                        {{
                          begaran()?.projektledare?.gender === 1
                            ? t('person_sex_male')
                            : begaran()?.projektledare?.gender === 2
                              ? t('person_sex_female')
                              : begaran()?.projektledare?.gender === 0
                                ? t('person_sex_other')
                                : ''
                        }}
                      </div>
                    </lib-input-container>
                  </div>
                }
                @if (!changeRequestEditPerson() && !personHasValues()) {
                  <button
                    vinnova-button-secondary
                    (click)="updateChangeRequestPerson()"
                    class="change-button"
                    [disabled]="readOnlySignal() !== ReadonlyState.Editable"
                  >
                    {{
                      isProjectManager()
                        ? t('begaran_change_project_manager')
                        : t('begaran_change_signatory')
                    }}
                  </button>
                }
                @if (changeRequestEditPerson() || personHasValues()) {
                  @for (
                    personForm of persons.controls;
                    track $index;
                    let i = $index
                  ) {
                    @if (
                      {
                        firstName:
                          errorMessages$.get(personForm.value.id)?.firstName
                          | async,
                        lastName:
                          errorMessages$.get(personForm.value.id)?.lastName
                          | async,
                        email:
                          errorMessages$.get(personForm.value.id)?.email
                          | async,
                        phone:
                          errorMessages$.get(personForm.value.id)?.phone
                          | async,
                        sex:
                          errorMessages$.get(personForm.value.id)?.sex | async,
                        role:
                          errorMessages$.get(personForm.value.id)?.role | async,
                      };
                      as errorMessages
                    ) {
                      <div class="change-person-header">
                        <div class="person-title">
                          {{
                            isProjectManager()
                              ? t('begaran_new_project_manager')
                              : t('begaran_new_signatory')
                          }}
                        </div>
                        <button
                          vinnova-button-text
                          size="small"
                          type="button"
                          (click)="onRemovePerson(i)"
                          [disabled]="
                            readOnlySignal() !== ReadonlyState.Editable
                          "
                          [attr.aria-label]="
                            title
                              ? t('list_item_remove') + ' ' + title
                              : undefined
                          "
                        >
                          <lib-icon name="trash"></lib-icon
                          ><span>{{ t('list_item_remove') }}</span>
                        </button>
                      </div>
                      <div class="information-details-container">
                        <button
                          vinnova-button-secondary
                          (click)="getInformationDetails(personForm)"
                          [disabled]="
                            readOnlySignal() !== ReadonlyState.Editable
                          "
                        >
                          {{ t('person_btn_get_info') }}
                          <span class="visually-hidden">
                            {{
                              question().translations?.list['title']
                                | translate: activeLang() : question().title
                            }}</span
                          >
                        </button>
                        <p class="person-detail-text">
                          {{ t('person_get_info_text') }}
                        </p>
                      </div>
                      <div class="edit-person-container">
                        @if (question().structure.firstName) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_firstname'),
                                suffix: '_firstName',
                                errorText: errorMessages.firstName,
                                maxlength: 50,
                                formControl: personForm.get('firstName'),
                                personIndex: i,
                                field: 'firstName',
                              }
                            "
                          ></ng-container>
                        }
                        @if (question().structure.lastName) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_lastname'),
                                suffix: '_lastName',
                                errorText: errorMessages.lastName,
                                maxlength: 50,
                                formControl: personForm.get('lastName'),
                                personIndex: i,
                                field: 'lastName',
                              }
                            "
                          ></ng-container>
                        }
                        @if (question().structure.email) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_email'),
                                suffix: '_email',
                                helpText: t('person_email_helptext'),
                                errorText: errorMessages.email,
                                maxlength: 50,
                                formControl: personForm.get('email'),
                                personIndex: i,
                                field: 'email',
                              }
                            "
                          ></ng-container>
                        }
                        @if (question().structure.phone) {
                          <div class="mt-2">
                            <lib-input-container
                              [label]="t('person_phone')"
                              [markRequired]="true"
                              [for]="
                                labelPrefix() + question().id + '_phone' + i
                              "
                              [width]="'medium'"
                              [errorText]="errorMessages.phone"
                              [inputType]="InputType.Text"
                            >
                              @if (!readOnlySignal()) {
                                <lib-dot-indicator
                                  type="text-input"
                                  [isVisible]="
                                    showChanges() &&
                                    previousAnswersService.hasPersonFieldChanged(
                                      question().id,
                                      repeaterGroupId(),
                                      i,
                                      'phone',
                                      personForm.get('phone').value
                                    )
                                  "
                                />
                                <lib-text-input-phone
                                  [formControl]="personForm.controls.phone"
                                  [required]="question().validation.required"
                                  [error]="!!errorMessages.phone"
                                  [id]="
                                    labelPrefix() + question().id + '_phone' + i
                                  "
                                ></lib-text-input-phone>
                              } @else {
                                <div
                                  class="readonly"
                                  [ngClass]="
                                    errorMessages.phone ? 'invalid' : ''
                                  "
                                >
                                  {{ readOnlyPhoneNumbers[i]() }}
                                </div>
                              }
                            </lib-input-container>
                          </div>
                        }

                        @if (question().structure.sex) {
                          <div class="mt-2">
                            <lib-input-container
                              [label]="t('person_sex')"
                              [errorText]="errorMessages.sex"
                              [markRequired]="true"
                              [width]="'medium'"
                              [requiredTextEnd]="false"
                            >
                              @if (!readOnlySignal()) {
                                <lib-vinnova-radiobuttons
                                  [radiobuttonObjects]="[
                                    {
                                      id: '2',
                                      label:
                                        translocoService.translate(
                                          'person_sex_female'
                                        ),
                                      value: '2',
                                    },
                                    {
                                      id: '1',
                                      label:
                                        translocoService.translate(
                                          'person_sex_male'
                                        ),
                                      value: '1',
                                    },
                                    {
                                      id: '0',
                                      label:
                                        translocoService.translate(
                                          'person_sex_other'
                                        ),
                                      value: '0',
                                    },
                                  ]"
                                  [formControl]="personForm.controls.sex"
                                  [error]="!!errorMessages.sex"
                                  [required]="question().validation.required"
                                  [name]="'person_gender_' + i"
                                  [showChangeIndicator]="
                                    showChanges() &&
                                    previousAnswersService.hasPersonFieldChanged(
                                      question().id,
                                      repeaterGroupId(),
                                      i,
                                      'sex',
                                      personForm.get('sex').value
                                    )
                                  "
                                >
                                </lib-vinnova-radiobuttons>
                              } @else {
                                <div
                                  class="readonly"
                                  [ngClass]="errorMessages.sex ? 'invalid' : ''"
                                >
                                  {{
                                    getPersonSexValue(
                                      personForm.get('sex').value
                                    )
                                  }}
                                </div>
                              }
                            </lib-input-container>
                          </div>
                        }
                      </div>
                    }
                  }
                }
              </div>
            </lib-list-item>
          </lib-list>
        </div>
      } @else {
        <ng-container formArrayName="persons">
          <div class="row mt-1">
            <div class="col-12 col-md-10">
              <lib-list
                [addMoreVisible]="allowedToAddMore && !readOnlySignal()"
                [addMoreText]="t('person_btn_add')"
                (addMore)="onAddPerson()"
              >
                @for (
                  personForm of persons.controls;
                  track $index;
                  let i = $index
                ) {
                  @if (
                    {
                      firstName:
                        errorMessages$.get(personForm.value.id)?.firstName
                        | async,
                      lastName:
                        errorMessages$.get(personForm.value.id)?.lastName
                        | async,
                      email:
                        errorMessages$.get(personForm.value.id)?.email | async,
                      phone:
                        errorMessages$.get(personForm.value.id)?.phone | async,
                      sex: errorMessages$.get(personForm.value.id)?.sex | async,
                      role:
                        errorMessages$.get(personForm.value.id)?.role | async,
                    };
                    as errorMessages
                  ) {
                    <lib-list-item
                      [formGroupName]="i"
                      [editMode]="true"
                      [onlyEditMode]="true"
                      [removeVisible]="
                        question().structure.projectRole !==
                          'isProjectManager' && !notAllowedToRemove
                      "
                      (remove)="onRemovePerson(i)"
                      [readOnlyState]="readOnlySignal()"
                      [title]="
                        question().structure.projectRole === 'isProjectManager'
                          ? t('person_project_manager')
                          : question().structure.projectRole === 'isSignatory'
                            ? t('person_signatory')
                            : undefined
                      "
                    >
                      @if (!readOnlySignal()) {
                        <div edit-title>
                          <button
                            vinnova-button-secondary
                            (click)="getInformationDetails(personForm)"
                          >
                            {{ t('person_btn_get_info') }}
                            <span class="visually-hidden">
                              {{
                                question().translations?.list['title']
                                  | translate: activeLang() : question().title
                              }}</span
                            >
                          </button>
                          <p class="person-detail-text">
                            {{ t('person_get_info_text') }}
                          </p>
                        </div>
                      }
                      <div edit>
                        @if (question().structure.firstName) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_firstname'),
                                suffix: '_firstName',
                                errorText: errorMessages.firstName,
                                maxlength: 50,
                                formControl: personForm.get('firstName'),
                                personIndex: i,
                                field: 'firstName',
                              }
                            "
                          ></ng-container>
                        }
                        @if (question().structure.lastName) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_lastname'),
                                suffix: '_lastName',
                                errorText: errorMessages.lastName,
                                maxlength: 50,
                                formControl: personForm.get('lastName'),
                                personIndex: i,
                                field: 'lastName',
                              }
                            "
                          ></ng-container>
                        }
                        @if (question().structure.email) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_email'),
                                suffix: '_email',
                                helpText: t('person_email_helptext'),
                                errorText: errorMessages.email,
                                maxlength: 50,
                                formControl: personForm.get('email'),
                                personIndex: i,
                                field: 'email',
                              }
                            "
                          ></ng-container>
                        }
                        @if (question().structure.phone) {
                          <div class="mt-2">
                            <lib-input-container
                              [label]="t('person_phone')"
                              [required]="question().validation.required"
                              [for]="
                                labelPrefix() + question().id + '_phone' + i
                              "
                              [width]="'medium'"
                              [errorText]="errorMessages.phone"
                              [inputType]="InputType.Text"
                            >
                              @if (!readOnlySignal()) {
                                <lib-dot-indicator
                                  type="text-input"
                                  [isVisible]="
                                    showChanges() &&
                                    previousAnswersService.hasPersonFieldChanged(
                                      question().id,
                                      repeaterGroupId(),
                                      i,
                                      'phone',
                                      personForm.get('phone').value
                                    )
                                  "
                                />
                                <lib-text-input-phone
                                  formControlName="phone"
                                  [required]="question().validation.required"
                                  [error]="!!errorMessages.phone"
                                  [id]="
                                    labelPrefix() + question().id + '_phone' + i
                                  "
                                ></lib-text-input-phone>
                              } @else {
                                <div
                                  class="readonly"
                                  [ngClass]="
                                    errorMessages.phone ? 'invalid' : ''
                                  "
                                >
                                  {{ readOnlyPhoneNumbers[i]() }}
                                </div>
                              }
                            </lib-input-container>
                          </div>
                        }
                        @if (question().structure.sex) {
                          <div class="mt-2">
                            <lib-input-container
                              [label]="t('person_sex')"
                              [errorText]="errorMessages.sex"
                              [required]="question().validation.required"
                              [width]="'medium'"
                              [requiredTextEnd]="false"
                            >
                              @if (!readOnlySignal()) {
                                <lib-vinnova-radiobuttons
                                  [radiobuttonObjects]="[
                                    {
                                      id: '2',
                                      label:
                                        translocoService.translate(
                                          'person_sex_female'
                                        ),
                                      value: '2',
                                    },
                                    {
                                      id: '1',
                                      label:
                                        translocoService.translate(
                                          'person_sex_male'
                                        ),
                                      value: '1',
                                    },
                                    {
                                      id: '0',
                                      label:
                                        translocoService.translate(
                                          'person_sex_other'
                                        ),
                                      value: '0',
                                    },
                                  ]"
                                  formControlName="sex"
                                  [error]="!!errorMessages.sex"
                                  [required]="question().validation.required"
                                  [name]="'person_gender_' + i"
                                  [showChangeIndicator]="
                                    showChanges() &&
                                    previousAnswersService.hasPersonFieldChanged(
                                      question().id,
                                      repeaterGroupId(),
                                      i,
                                      'sex',
                                      personForm.get('sex').value
                                    )
                                  "
                                >
                                </lib-vinnova-radiobuttons>
                              } @else {
                                <div
                                  class="readonly"
                                  [ngClass]="errorMessages.sex ? 'invalid' : ''"
                                >
                                  {{
                                    getPersonSexValue(
                                      personForm.get('sex').value
                                    )
                                  }}
                                </div>
                              }
                            </lib-input-container>
                          </div>
                        }
                        @if (question().structure.role) {
                          <ng-container
                            *ngTemplateOutlet="
                              standardPerson;
                              context: {
                                label: t('person_role'),
                                suffix: '_role',
                                errorText: errorMessages.role,
                                maxlength: 50,
                                formControl: personForm.get('role'),
                                personIndex: i,
                                field: 'role',
                              }
                            "
                          ></ng-container>
                        }
                      </div>
                    </lib-list-item>
                  }
                }
              </lib-list>
            </div>
          </div>
        </ng-container>
      }
      <ng-template
        #standardPerson
        let-label="label"
        let-suffix="suffix"
        let-errorText="errorText"
        let-maxlength="maxlength"
        let-formControl="formControl"
        let-personIndex="personIndex"
        let-field="field"
        let-helpText="helpText"
      >
        <div class="mt-2">
          <lib-input-container
            [label]="label"
            [required]="question().validation.required"
            [markRequired]="isChangeRequest()"
            [for]="labelPrefix() + question().id + suffix + i"
            [errorText]="errorText"
            [inputType]="InputType.Text"
            [width]="'medium'"
            [helpText]="helpText"
          >
            @if (!readOnlySignal()) {
              <lib-dot-indicator
                type="text-input"
                [isVisible]="
                  showChanges() &&
                  previousAnswersService.hasPersonFieldChanged(
                    question().id,
                    repeaterGroupId(),
                    personIndex,
                    field,
                    formControl.value
                  )
                "
              />
              <input
                vinnova-text-input
                [maxlength]="maxlength"
                [id]="labelPrefix() + question().id + suffix + i"
                [required]="question().validation.required"
                [formControl]="formControl"
                [placeholder]="question().structure.placeholder"
                [error]="!!errorText"
                [inputType]="InputType.Text"
              />
            } @else {
              <div class="readonly" [ngClass]="errorText ? 'invalid' : ''">
                {{ formControl.value }}
              </div>
            }
          </lib-input-container>
        </div>
      </ng-template>
    </lib-input-container>
  </div>
</ng-container>
